import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { DELEGATE_KEY } from "../../lib/delegate";
import { SNAPSHOT, SnapshotNotice } from "../../lib/snapshot";

export default function DelegateVerify({ status, onVerified }) {
  const [form, setForm] = useState({ email: "", reference: "", code: "" });
  const [stage, setStage] = useState("request");
  const [notice, setNotice] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const request = async (e) => {
    e?.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/virtual/request-code", { email: form.email, reference: form.reference }); setNotice(data.message); setStage("verify"); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const verify = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/virtual/verify-code", form);
      sessionStorage.setItem(DELEGATE_KEY, data.token); onVerified();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-lg" data-testid="delegate-verify">
      {!status.email_configured && (
        <p className="mb-5 rounded border border-gold bg-[#FFFBF0] p-4 text-sm text-navy" role="status" data-testid="virtual-live-disabled-notice">
          <b>{status.live_disabled_message}</b>
          {status.dev_test_codes && <span className="block">TEST MODE: for test registrations the code is written to the admin Email Communications log (TEST ONLY: does not verify email ownership).</span>}
        </p>
      )}
      {stage === "request" ? (
        <form onSubmit={request} className="space-y-4" data-testid="delegate-request-form">
          <h2 className="text-2xl text-navy">Verify your registration</h2>
          <SnapshotNotice />
          <p className="text-[#4A5568]">Enter the email and registration reference from your confirmation. We will send a one-time code to that email.</p>
          <div><label htmlFor="v-email" className="field-label">Email address</label>
            <input id="v-email" type="email" required autoComplete="email" className="field-input" value={form.email} onChange={set("email")} data-testid="delegate-email-input" /></div>
          <div><label htmlFor="v-ref" className="field-label">Registration reference</label>
            <input id="v-ref" required className="field-input uppercase" placeholder="CIARB26-XXXXXX" value={form.reference} onChange={set("reference")} data-testid="delegate-reference-input" /></div>
          <button type="submit" className="btn-primary w-full" disabled={busy || SNAPSHOT} data-testid="delegate-send-code-btn">{busy ? "Sending…" : "Send one-time code"}</button>
        </form>
      ) : (
        <form onSubmit={verify} className="space-y-4" data-testid="delegate-verify-form">
          <h2 className="text-2xl text-navy">Enter your code</h2>
          <p role="status" className="text-sm text-[#4A5568]" data-testid="delegate-code-notice">{notice}</p>
          <div><label htmlFor="v-code" className="field-label">6-digit code</label>
            <input id="v-code" required inputMode="numeric" autoComplete="one-time-code" className="field-input text-center text-2xl tracking-[0.5em]"
              value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.replace(/\D/g, "").slice(0, 6) })} aria-describedby="v-code-hint" data-testid="delegate-code-input" />
            <p id="v-code-hint" className="mt-1 text-xs text-[#4A5568]">Type or paste the 6 digits; spaces are ignored.</p></div>
          <button type="submit" className="btn-primary w-full" disabled={busy || form.code.length !== 6} data-testid="delegate-verify-btn">{busy ? "Verifying…" : "Verify & continue"}</button>
          <div className="flex justify-between text-sm">
            <button type="button" className="font-semibold text-burgundy" onClick={request} disabled={busy} data-testid="delegate-resend-btn">Resend code</button>
            <button type="button" className="text-[#4A5568]" onClick={() => setStage("request")} data-testid="delegate-change-details-btn">Change details</button>
          </div>
        </form>
      )}
    </div>
  );
}
